<div class="personal-details" #modalBody>
  <h2 class="personal-details-header">Personal Details</h2>
  @for (formGroup of applicantFormGroups; track formGroup; let i = $index) {
    <ng-container [ngTemplateOutlet]="applicantForm"
    [ngTemplateOutletContext]="{formGroup:formGroup, index: i + 1}"></ng-container>
  }
  <div class="d-flex mt-5">
    <button (click)="submit()" class="btn btn-primary btn-lg personal-details-button">
      Submit
    </button>
    <button (click)="closeModal()" class="btn btn-outline-dark btn-lg ms-3 personal-details-button">Cancel</button>
  </div>
</div>

<ng-template #applicantForm let-formGroup="formGroup" let-index="index">
  <div class="personal-details-applicant">
    @if (fewApplicants) {
      <div class="personal-details-applicant-title mb-2">
        Applicant {{index}}
      </div>
    }
    <form [formGroup]="formGroup">
      <div>
        <p>
          To get a call back about our Retirement Interest Only Mortgage, and discuss all your options, please complete
          the form.
          If you'd like to receive information about our products and services you can also opt-in by providing your
          email address.
        </p>
        <p>
          We'll never share your details with third parties for their own marketing purposes. Details of how we process
          your information can be found in our
          <a href="https://www.legalandgeneral.com/privacy-policy/" target="_blank">privacy policy</a>.
          You can opt out of marketing at any time by emailing
          <a href="mailto:LGFAoptout@landg.com">LGFAoptout&#64;landg.com</a>.
        </p>
      </div>
      <div>
        <div class="row personal-details-row mt-4">
          <label class="personal-details-label" for="firstName">First Name</label>
          <input class="form-control" formControlName="firstName"
            [class.is-invalid]="isControlInvalid('firstName', formGroup)"
            [class.is-valid]="isControlValid('firstName', formGroup)" />
          @if (isControlInvalid('firstName', formGroup)) {
            <div class="invalid-feedback alert alert-danger mt-2 d-flex"
              [style.display]="'block'">
              <img class="error-icon" src="assets/icons/crossmark-spot-filled.svg">
              <span class="ms-3">First Name is required.</span>
            </div>
          }
        </div>
        <div class="row personal-details-row mt-4">
          <label class="personal-details-label" for="lastName">Last Name</label>
          <input class="form-control" formControlName="lastName"
            [class.is-invalid]="isControlInvalid('lastName', formGroup)"
            [class.is-valid]="isControlValid('lastName', formGroup)" />
          @if (isControlInvalid('lastName', formGroup)) {
            <div class="invalid-feedback alert alert-danger mt-2 d-flex"
              [style.display]="'block'">
              <img class="error-icon" src="assets/icons/crossmark-spot-filled.svg">
              <span class="ms-3">Last Name is required.</span>
            </div>
          }
        </div>
        <div class="row personal-details-row mt-4">
          <label class="personal-details-label" for="phoneNumber">Phone Number</label>
          <input class="form-control" type="text" formControlName="phoneNumber"
            [class.is-invalid]="isControlInvalid('phoneNumber', formGroup)"
            [class.is-valid]="isControlValid('phoneNumber', formGroup)" />
          @if (isControlInvalid('phoneNumber', formGroup) && isControlEmpty('phoneNumber', formGroup)) {
            <div
              class="invalid-feedback alert alert-danger mt-2 d-flex" [style.display]="'block'">
              <img class="error-icon" src="assets/icons/crossmark-spot-filled.svg">
              <span class="ms-3">Phone Number is required.</span>
            </div>
          }
          @if (isControlInvalid('phoneNumber', formGroup) && !isControlEmpty('phoneNumber', formGroup)) {
            <div
              class="invalid-feedback alert alert-danger mt-2 d-flex" [style.display]="'block'">
              <img class="error-icon" src="assets/icons/crossmark-spot-filled.svg">
              <span class="ms-3">Please enter a valid Phone Number.</span>
            </div>
          }
        </div>
        <div class="mt-4">
          <p>
            By submitting this form you consent to us calling you to discuss how the products
            and services provided by Legal & General Financial Advice may work for you.
          </p>
        </div>
        <div class="row personal-details-row mt-4">
          <label class="personal-details-label" for="emailAddress">Email address</label>
          <input class="form-control" formControlName="emailAddress"
            [class.is-invalid]="isControlInvalid('emailAddress', formGroup)"
            [class.is-valid]="isControlValid('emailAddress', formGroup)" />
          @if (isControlInvalid('emailAddress', formGroup)) {
            <div
              class="invalid-feedback alert alert-danger mt-2 d-flex" [style.display]="'block'">
              <img class="error-icon" src="assets/icons/crossmark-spot-filled.svg">
              <span class="ms-3">Please enter a valid Email Address.</span>
            </div>
          }
        </div>
        <div class="mt-4">
          <p>
            By providing your email address you're giving consent for us to send you emails with news, information and
            offers
            on the products and services provided by Legal & General Financial Advice. We'll never share your details
            with third
            parties for their own marketing purposes.
          </p>
        </div>
        <div class="row personal-details-row mt-4">
          <label class="personal-details-label" for="postCode">Post Code</label>
          <input class="form-control" formControlName="postCode"
            [class.is-invalid]="isControlInvalid('postCode', formGroup)"
            [class.is-valid]="isControlValid('postCode', formGroup)" />
          @if (isControlInvalid('postCode', formGroup)) {
            <div class="invalid-feedback alert alert-danger mt-2 d-flex"
              [style.display]="'block'">
              <img class="error-icon" src="assets/icons/crossmark-spot-filled.svg">
              <span class="ms-3"> Please enter a valid Post Code.</span>
            </div>
          }
        </div>
      </div>
    </form>
  </div>
</ng-template>